// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chart-column.js';

import { paths } from '../generated/chart-column';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chart-column', Original, paths);
